import { z } from "zod";
import { nonRoutableEmployeePerformedActivityOccurrenceOrGroupSchema } from "./activities";
import { routeSchema } from "./routes";
import { scheduledShiftSchema } from "./shifts";

// A shift holds routes, which carry routable work, alongside standalone
// non-routable occurrences and groups.
export const shiftWithContentsSchema = z.object({
  shift: scheduledShiftSchema,
  items: z.array(
    z.union([
      routeSchema,
      nonRoutableEmployeePerformedActivityOccurrenceOrGroupSchema,
    ]),
  ),
});
export type IShiftWithContents = z.infer<typeof shiftWithContentsSchema>;
export type IShiftItem = IShiftWithContents["items"][number];
